import React from 'react';
import SEOHead from '../../components/SEOHead';
import PublicLayout from '../../components/site/PublicLayout';
import PageBanner from '../../components/site/PageBanner';
import { useLanguage } from '../../context/LanguageContext';
import Rooms from '../../components/Rooms';
import WhyBookDirect from '../../components/WhyBookDirect';
import Amenities from '../../components/Amenities';
import Gallery from '../../components/Gallery';
import InstagramGrid from '../../components/InstagramGrid';
import SocialFeeds from '../../components/SocialFeeds';
import VirtualTour from '../../components/VirtualTour';
import Location from '../../components/Location';
import ExploreUlcinj from '../../components/ExploreUlcinj';
import Testimonials from '../../components/Testimonials';
import GoogleReviews from '../../components/GoogleReviews';
import FaqSection from '../../components/FaqSection';
import Contact from '../../components/Contact';
import SeoLanding from '../../components/SeoLanding';

const SECTIONS = {
  rooms: [Rooms, WhyBookDirect],
  amenities: [Amenities],
  gallery: [Gallery, InstagramGrid, SocialFeeds],
  'virtual-tour': [VirtualTour],
  location: [Location, ExploreUlcinj],
  reviews: [GoogleReviews, Testimonials],
  faq: [FaqSection],
  contact: [Contact],
};

// One route per main-menu section; the existing section components render unchanged under a page banner.
export default function SitePage({ slug }) {
  const { t } = useLanguage();
  const copy = t(`pages.${slug}`);
  const title = typeof copy === 'object' ? copy.title : slug;
  return (
    <PublicLayout>
      <SEOHead page={slug} />
      <PageBanner slug={slug} title={title} subtitle={typeof copy === 'object' ? copy.sub : ''} />
      <main data-testid={`page-${slug}`}>
        {SECTIONS[slug].map((Section) => <Section key={Section.displayName || Section.name} />)}
        <SeoLanding slug={slug} />
      </main>
    </PublicLayout>
  );
}
